import _, { times } from 'lodash';
import React, { Fragment } from 'react';
import autobind from 'autobind-decorator';
import { observer, inject } from 'mobx-react';

import ArtistsListSection from '../artists-list-section.js/artists-list-section';
@inject('searchStore', 'songsStore', 'membersBFFStore')
@observer
export class Search
extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { searchStore } = this.props;

		return (
			<Fragment>
				<div className="grid-x grid-padding-x" style={{position: 'relative', justifyContent:'center', width: '99.1vw'}}>
					<div className="cell small-5">
						<div className="mainSearch">
							<input 
								id="search-bar"
								className="open"
								style={{marginTop: '1.5vh'}}
								type="text" 
								placeholder="Search" 
								onChange={ this.onChange } 
								value={ searchStore.searchTerm } 
							/>
						</div>
					</div>
				</div>
				<div className="grid-x grid-padding-x" style={{position: 'relative', alignItems: 'center', paddingLeft:'2vw'}}>
					<div style={{display: 'flex'}}>
						<div className="cell auto">
							<div className="padding-top-1">
								{ this.renderArtistResults() }
							</div>

							<div className="padding-top-1">
								{ this.renderAlbumResults() }
							</div>

							<div className="cell small-12">
								{ this.renderSongResults() }
							</div>

							{_.isEmpty(searchStore.searchResults) &&
								(
									<div className="cell small-12 text-center" style={{width:'95vw'}}>
										{searchStore.searchTerm?.length === 0 && (
											<div className="no-result-text dropfade-text">Search for songs, artists, and albums</div>
										)}
										{searchStore.searchTerm?.length > 3 && (
											<div className="no-result-text dropfade-text">No results found for "{searchStore.searchTerm}"</div>
										)}
									</div>
								)

							}
						</div>
					</div>
				</div>
			</Fragment>
		);
	}


	@autobind
	onPlayClick (newList, songIndex) {
		const { membersBFFStore } = this.props;
				// const { paths: { profileImgBasePath } } = config;
				// const imagePath = `${profileImgBasePath}/${user.profileImage}`;
		
				let list = [...newList];
				list.splice(0,songIndex);
		
				membersBFFStore.setCurrentPlaylist({
					list, name: '', imagePath:''
				});
		
				sessionStorage.setItem("scrollPosition", window.pageYOffset);
	}

	@autobind
	async onChange ({ target: { value } }) {
		const { searchStore } = this.props;
		searchStore.searchTerm = value;
		await searchStore.search();
	}

	@autobind
	renderArtistResults () {
		const { searchStore } = this.props;

		if (_.isEmpty(searchStore.artistResults)) {
	
			return null;
		}
	
		return (
			<div className="search-section-header">
				<ArtistsListSection
					sectionLabel="Artists"
					artists={ searchStore.artistResults }
					mode="list"
					hideFunc={this.hideSearch}
				/>
			</div>
		);
	
	}
	
	@autobind
	renderAlbumResults () {
		const {searchStore} = this.props;
		if (_.isEmpty(searchStore.albumResults)) {
	
			return null;
		}
	
		return (
			<div className="search-section-header">
				<ArtistsListSection
					sectionLabel="Albums"
					artists={ searchStore.albumResults }
					mode="list"
					hideFunc={this.hideSearch}
				/>
			</div>
		);
	
	}
	
	@autobind
	renderSongResults () {
		const { searchStore } = this.props;
	
		console.log('Search Render', searchStore.songResults);
		if (_.isEmpty(searchStore.songResults)) {
	
			return null;
		}
	
		return (
			<Fragment>
				<div className="search-section-header">
					<h3 className="section-title padding-bottom-1">Songs</h3>
					<ul style={{listStyleType: 'none'}}>
						{
							searchStore.songResults.map((song) => {
								const artist = {};//artistStore.getItemByID(song.artistID);
	
								return (
									<li key={ song.id } className="margin-bottom-1">
										<div className="grid-x">
											<div
												onClick={() => this.onPlayClick([song],song.id)}
												className="new-releases-tile"
												style={
													{
														backgroundImage: `url(${song.artwork})`
													}
												}
											>
												{song.artwork === undefined ?
													(<i className="fal fa-music-alt" style={{
														fontSize: '50px',
														color: '#cccccc',
														marginLeft: '21%',
														marginTop: '13%',
													}}>
	
													</i>) : (<span/>)
												}
											</div>
											<div className="margin-left-1 margin-top-1">
												<Fragment>
													<div className="sr-song-title">{ song.title }</div>
													<div className="sr-song-details">
														{ `${song.artistName} - ${song.duration}` }
													</div>
												</Fragment>
											</div>
										</div>
									</li>
								);
							})
						}
					</ul>
				</div>
			</Fragment>
		);
	}

	@autobind
	toggleSearchBtn () {
		if(!this.state.isOpened) {
			document.querySelector('#search-bar').focus();
		}
		this.setState({isOpened: !this.state.isOpened});
		this.props.clearFunc();
	}

	@autobind
	searchBarBlur () {
		console.log("BLURRED")
	}

	@autobind
	hideSearch () {
		// const {artistStore, songsStore, albumsStore} = this.props;
		// albumsStore.searchTerm = artistStore.searchTerm = songsStore.searchTerm = "";
		// artistStore.search();
	}
}
